import { useLocation } from "react-router-dom";
import { LuLock } from "react-icons/lu";
import { iconFor } from "./navIcons";
import * as styled from "./NavBar.styled.jsx";

function NavBar({ navList, currentRoute, setShowMenu }) {
  const location = useLocation();

  return (
    <styled.List>
      {navList.map(({ name, link }) => {
        const isClosed = link.length === 0;
        const base = `${currentRoute}/${link}`;
        // Активний і на вкладених сторінках розділу (наприклад, materials/adults/Beginner)
        const isActive = !isClosed && (location.pathname === base || location.pathname.startsWith(`${base}/`));
        const Icon = iconFor(link, name);

        return (
          <li key={name}>
            {isClosed ? (
              <styled.Closed title="Доступно після першого уроку">
                <Icon size={20} />
                <span>{name}</span>
                <LuLock size={15} className="lock" />
              </styled.Closed>
            ) : (
              <styled.StyledLink to={link} $active={isActive} onClick={() => setShowMenu(false)}>
                <Icon size={20} />
                <span>{name}</span>
              </styled.StyledLink>
            )}
          </li>
        );
      })}
    </styled.List>
  );
}

export default NavBar;
